import { alphabeticRegex, phoneRegex } from "@/lib/regexHelper"
import { z } from "zod"

export const personalDetailsFormSchema = z.object({
  firstName: z
    .string()
    .min(1, "First name is required")
    .regex(
      alphabeticRegex,
      "Name can only include letters and spaces. No numbers or special characters",
    )
    .min(2, "Name must be at least 2 characters long"),
  lastName: z
    .string()
    .min(1, "Last name is required")
    .regex(
      alphabeticRegex,
      "Name can only include letters and spaces. No numbers or special characters",
    )
    .min(2, "Name must be at least 2 characters long"),
  emailAddress: z
    .string()
    .min(1, "Email address is required")
    .email("Please enter a valid email"),
  phoneNumber: z
    .string()
    .min(1, "Valid phone number is required")
    .regex(phoneRegex, "Please enter a valid phone number"),
  title: z.string().optional(),
  consentToPrivacyPolicy: z.boolean().refine((val) => val === true, {
    message: "Please accept the terms and conditions before continuing",
  }),
  isAuthorisedToAlter: z.boolean().refine((val) => val === true, {
    message:
      "Please confirm that you are the property owner or have permission to carry out alterations",
  }),
})
